export class MobilePayError extends Error {
    name:string;
    error: {
        message: string;
    };

    constructor(message: string,name="MobilePayError") {
        super(message);
        this.name = name;
        this.error = {
            message: message
        };
    }
}